import MyHeader from "../components/headerComponent.js";
import Navbar from "../components/nav.js";
import Main from "../components/mainComponent.js";
import SocialsBar from "../components/socialsBar.js";
import MyFooter from "../components/footerComponent.js";

// import favicon from "./images/logos/BSCFavicon.jpg";

function Home() {
  return (
    <div className="Home">
      <header>
        <MyHeader />
        <Navbar />
      </header>
      <main>
        <Main />
      </main>
      <footer>
        <SocialsBar />
        <MyFooter />
      </footer>
    </div>
  );
}

export default Home;
